/**
 * List of English words commonly used in French that should be marked
 * with lang="en" for accessibility.
 */
export const ENGLISH_WORDS_IN_FRENCH = ['onboarding'] as const;

export const ENGLISH_WORDS_PATTERN = new RegExp(
  `\\b(${ENGLISH_WORDS_IN_FRENCH.join('|')})\\b`,
  'gi',
);
